
import React from 'react';
import { useSelector } from 'react-redux';

import {
    getUsekMezAttributes,
    getUsekMezItems
} from '../../reducers/project';

import Usek from './Usek.state';
import UsekListView from './UsekList.view';

const UsekList = () => {

    const usekMezItems = useSelector(state => getUsekMezItems(state.project));
    const usekMezAttributes = useSelector(state => getUsekMezAttributes(state.project));

    const handleRenderUsek = (usek, n) => {
        const usekId = usek.properties.id_usek;
        return (
            <Usek
                col={n}
                key={usekId}
                usek={usek}
                attributes={usekMezAttributes[usekId]}
            />
        );
    }

    return (
        <UsekListView
            usekItems={usekMezItems}
            onRenderUsek={handleRenderUsek}
        />
    );
}

export default UsekList;
